import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Heart = function Heart(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9932 5.1358C9.9938 2.7984 6.6598 2.1696 4.1547 4.31s-2.8577 5.719-.8905 8.2504c1.6356 2.1047 6.5856 6.5437 8.2079 7.9804.1815.1608.2723.2411.3781.2727a.504.504 0 0 0 .2859 0c.1058-.0316.1966-.1119.3781-.2727 1.6223-1.4367 6.5723-5.8757 8.2079-7.9804 1.9672-2.5314 1.6576-6.1325-.8905-8.2504-2.5481-2.1178-5.8391-1.5116-7.8384.8258",
      clipRule: "evenodd"
    })
  }));
};
export default Heart;